/**
 * Leads Configuration
 * Configurações centralizadas do módulo de Leads
 */

export const LEADS_CONFIG = {
  // Mostrar colunas de arquivados (Convertido/Perdido) por padrão?
  SHOW_ARCHIVED_BY_DEFAULT: false,

  // Auto-ocultar leads convertidos após X dias
  AUTO_HIDE_CONVERTED_AFTER_DAYS: 7,

  // Auto-ocultar leads perdidos após X dias
  AUTO_HIDE_LOST_AFTER_DAYS: 14,

  // Mostrar contador de leads arquivados?
  SHOW_ARCHIVED_COUNT_BADGE: true,

  // Mostrar banner informativo quando leads estão ocultos?
  SHOW_ARCHIVED_INFO_BANNER: true,
} as const;

export type LeadsConfig = typeof LEADS_CONFIG;
